import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error('Mínimo 6 caracteres');
    if (password !== confirm) return toast.error('Las contraseñas no coinciden');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
      toast.success('Contraseña restablecida');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al restablecer');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', background: '#000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
        <div style={{ textAlign: 'center' }}>
          <h2>Enlace inválido</h2>
          <p style={{ color: '#9ca3af' }}>Falta el token de recuperación.</p>
          <button onClick={() => navigate('/login')} style={{ marginTop: '1rem', padding: '0.75rem 1.5rem', background: '#00ffff', border: 'none', borderRadius: '0.5rem', fontWeight: 'bold', cursor: 'pointer' }}>Ir al login</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #000, #1a1a1a)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: '#111', border: '1px solid #00ffff', borderRadius: '1.5rem', padding: '2rem', width: '100%', maxWidth: '400px' }}>
        <h1 style={{ textAlign: 'center', background: 'linear-gradient(135deg, #00ffff, #ff00ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '0.5rem' }}>Nueva contraseña</h1>
        {email && <p style={{ color: '#9ca3af', textAlign: 'center', fontSize: '0.8rem', marginBottom: '1.5rem' }}>{email}</p>}

        {done ? (
          <div style={{ textAlign: 'center', color: '#00ff88' }}>
            <p>✅ Contraseña actualizada</p>
            <p style={{ color: '#9ca3af', fontSize: '0.8rem' }}>Redirigiendo al login...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', color: '#9ca3af', fontSize: '0.8rem', marginBottom: '0.25rem' }}>Nueva contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff', marginBottom: '1rem' }} />
            <label style={{ display: 'block', color: '#9ca3af', fontSize: '0.8rem', marginBottom: '0.25rem' }}>Confirmar contraseña</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required style={{ width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff', marginBottom: '1.25rem' }} />
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '1rem', background: 'linear-gradient(135deg, #00ffff, #ff00ff)', border: 'none', borderRadius: '0.5rem', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }}>
              {loading ? 'Guardando...' : 'Restablecer contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
